module.exports = __webpack_public_path__ + "img/techem.bc9a4e14.png";